import React from "react";
import { Box, Paper, Skeleton } from "@mui/material";
import CreateSectionHeader from "../CreateNotice/CreateSectionHeader";
import PageContainer from "../PageContainer";

export const NEW_NOTICE_TEMPLATE_TITLE = "New template";

export const NOTICE_TEMPLATE_SUBTITLE =
  "Save a notice you send often so you can start from it next time.";

/** Shown while a Template loads: its header, then grey fields beside the backgrounds. */
const NoticeTemplateSkeleton: React.FC<{ title?: string }> = ({
  title = "Template",
}) => (
  <PageContainer>
    <CreateSectionHeader
      title={title}
      subtitle={NOTICE_TEMPLATE_SUBTITLE}
      crumbs={[]}
    />
    <Paper
      variant="outlined"
      role="status"
      aria-label="Loading Template"
      sx={{
        borderRadius: 2,
        p: { xs: 2, sm: 3 },
        display: "grid",
        gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(2, minmax(0, 1fr))" },
        gap: { xs: 2.5, md: 4 },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        <Skeleton variant="rounded" height={40} />
        <Skeleton variant="rounded" height={88} />
        <Skeleton variant="rounded" height={56} />
        <Skeleton variant="rounded" height={40} />
        <Skeleton variant="rounded" height={160} />
        <Skeleton variant="rounded" height={40} />
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          gap: 1.5,
          alignContent: "start",
        }}
      >
        {[0, 1, 2, 3, 4, 5].map((tile) => (
          <Skeleton key={tile} variant="rounded" height={120} />
        ))}
      </Box>
    </Paper>
  </PageContainer>
);

export default NoticeTemplateSkeleton;
